import { useSuspenseQuery } from '@tanstack/react-query';

import {
  getDoctoralCommitteeValidationOptions,
  useValidateDoctoralCommittee,
} from '@/module/Author/DoctoralCommittee/Validation/model/DoctoralCommitteeValidationModel';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

interface ValidationActionProps {
  doctoralCommitteeId: Id;
  variant?: ValidationVariant;
}

export function DoctoralCommitteeValidationAction({ doctoralCommitteeId, variant }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getDoctoralCommitteeValidationOptions(doctoralCommitteeId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidateDoctoralCommittee(doctoralCommitteeId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
